export default "__VITE_ASSET__Cs5G4_h4__"